<template>
  <el-container id="imgGlSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background: #FFFFFF;">
        <p style="font-size:20px;margin-left:20px;font-weight:bold;height:20px;line-height:20px">{{ h_text }}</p>
        <!--        <div style="margin-top: 10px;padding-left:20px">-->
        <!--          <p style="margin-top:5px;margin-bottom:5px">标题</p>-->
        <!--          <el-input :disabled="noOperate" v-model="ediTitle" maxlength="30" placeholder="请输入标题"-->
        <!--                    style="width:98%"></el-input>-->
        <!--        </div>-->
        <div style="display:flex">
          <div style="margin-top:10px;padding-left:20px;">
            <p style="margin-top:5px;margin-bottom:5px">封面图(750*1152)</p>
            <div class="image-slot" style="display:flex;">
              <el-image :src="imageUrl" key="fit" style="width:20vh;height:30vh">
                <div slot="error" style="background-color:#F4F4F4;height:100%;width:100%">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div style="position:relative;">
                <el-upload
                  class="avatar-uploader"
                  :action=url_upFile
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"> <!--:http-request="uploadFile"-->
                  <el-button :disabled="noOperate" type="primary" icon="el-icon-upload"
                             style="font-size:15px;line-height:15px;margin-left:5px;position:absolute;bottom: 0;">上传封面图
                  </el-button>
                </el-upload>
              </div>
            </div>
          </div>
          <div style="margin-top:10px;padding-left:30%;">
            <p style="margin-top:5px;margin-bottom:5px">详情图(750*1448)</p>
            <div class="image-slot" style="display:flex;">
              <el-image :src="imageUrl1" style="width:15.7vh;height:30vh">
                <div slot="error" style="background-color:#F4F4F4;height:100%;width:100%">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div style="position:relative;">
                <el-upload
                  class="avatar-uploader"
                  :action=url_upFile
                  :auto-upload="true"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess1"
                  :before-upload="beforeAvatarUpload1"> <!--:http-request="uploadFile1"-->
                  <el-button :disabled="noOperate" type="primary" icon="el-icon-upload"
                             style="font-size:15px;line-height:15px;margin-left:5px;position:absolute;bottom: 0;">上传详情图
                  </el-button>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;width:98%;margin-top:20px">
          <el-button v-if="!noOperate" style="margin-left:auto;margin-right:1px;height:40px" type="info"
                     @click="onBack"
                     icon="el-icon-close">取消
          </el-button>
          <el-button v-if="noOperate"
                     style="margin-right:1px;height:40px;margin-left:auto;" @click="onBack" type="info"
                     icon="el-icon-back">返回
          </el-button>
          <el-button v-if="!noOperate" type="primary" @click="onKeep(true)" icon="el-icon-s-promotion"
                     style="height: 40px">发布
          </el-button>
          <el-button v-if="!noOperate" type="primary" @click="onKeep(false)" style="height: 40px">保存草稿
          </el-button>
        </div>
      </el-main>
    </el-container>
    <el-dialog top="2vh" width="60vw" title="图片裁剪" :show-close="true"
               :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="cropper-w" style="margin:0">
        <div class="cropper" :style="{textAlign:'center',height: img_h }">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="option.info"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixedBox="option.fixedBox">
          </vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import axios from 'axios';
import vueCropper from '../views/vueCropper.vue';

export default {
  name:"imgGlSon",
  components:{
    vueCropper
  },
  data(){
    return {
      h_text:"新增公告",
      noOperate:false,
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""},
        {"text":"轮播图管理","colour":"#B7B7B7","pages":""}
      ],
      img_w:"375px",
      img_h:"75vh",
      dialogVisible:false,
      page:1,
      pageSize:10,
      total:0,
      edi_auth:"",
      li_auth:[],
      authPage:1,
      authPageSize:10,
      authTotal:10,
      zhName:"",
      password:"",
      nickName:"", /*账号*/
      value3:"",
      imageUrl:"",
      imageUrl1:"",
      imageId:-1,
      imageId1:-1,
      url_upFile:"",
      ediTitle:"", /*活动名称*/
      ediDetail:"", /*活动详情*/
      ediApplyStart:"", /*报名开始时间*/
      ediApplyEnd:"", /*报名结束时间*/
      ediValidStart:"", /*活动开始时间*/
      ediValidEnd:"", /*活动结束时间*/
      ediMaxApplys:"", /*最大报名个数*/
      ImageUrl:[], /*活动宣传图片*/
      CoverFile:"", /*活动封面图片*/
      CoverFileId:"", /*活动封面图片id*/
      sort:"", /*排序*/
      stateId:1, /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
      id:"",
      isCtr:true,
      isTop:false, /*是否置顶*/
      isBm:false, /*是否开启报名限制*/
      option:{
        img:"", // 裁剪图片的地址
        info:true, // 裁剪框的大小信息
        outputSize:0.8, // 裁剪生成图片的质量
        outputType:"jpeg", // 裁剪生成图片的格式
        canScale:false, // 图片是否允许滚轮缩放
        autoCrop:true, // 是否默认生成截图框
        autoCropWidth:375, // 默认生成截图框宽度
        autoCropHeight:562, // 默认生成截图框高度
        fixedBox:false, // 固定截图框大小 不允许改变
        fixed:false, // 是否开启截图框宽高固定比例
        fixedNumber:[
          7,
          5
        ], // 截图框的宽高比例
        full:true, // 是否输出原图比例的截图
        canMoveBox:true, // 截图框能否拖动
        original:true, // 上传图片按照原始比例渲染
        centerBox:true, // 截图框是否被限制在图片里面
        infoTrue:true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      }
    };
  },
  methods:{ /*方法存放*/
    handleSelectMenu(path){ /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    onKeep(stateId){
      if(!(this.imageUrl)) {
        this.$message.info('请先上传封面图');
        return;
      } else if(!(this.imageUrl1)) {
        this.$message.info('请先上传详情图');
        return;
      }
      if(this.isCtr) {
        this.isCtr = false;
        if(this.h_text === '新增轮播图') {
          this.addNotice(stateId);
        } else {
          this.changeNotice(stateId);
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    beforeAvatarUpload(file){
      this.upImg = 0;
      console.log(file.type);
      //this.img_w = "375px";
      //this.img_h = "562px";
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if(!isJPG) {
        this.$message.error('只能上传png/jpg格式的图片');
        return false;
      }
      if(!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }

      // 图片转为base64
      let self = this;
      const _URL = window.URL || window.webkitURL;
      const image = new Image();
      image.src = _URL.createObjectURL(file);
      self.option.img = image.src;
      //image.onload = function () {
      //  let base64 = self.transBase64FromImage(image);
      //  self.option.img = base64;
      //};
      this.dialogVisible = true;
    },
    beforeAvatarUpload1(file){
      console.log(file.type);
      this.upImg = 1;
      //this.img_w = "375px";
      //this.img_h = "667px";
      // 图片转为base64
      let self = this;
      const _URL = window.URL || window.webkitURL;
      const image = new Image();
      image.src = _URL.createObjectURL(file);
      self.option.img = '';
      image.onload = function(){
        let base64 = self.transBase64FromImage(image);
        self.option.img = base64;
      };
      this.dialogVisible = true;

      //const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      //const isLt2M = file.size / 1024 / 1024 < 2;
      //
      //if (!isJPG) {
      //  this.$message.error('只能上传png/jpg格式的图片');
      //  return false;
      //}
      //if (!isLt2M) {
      //  this.$message.error('上传头像图片大小不能超过 2MB!');
      //  return false;
      //}
      //return true; // 如果校验通过，返回true继续上传流程
    },
    // 将网络图片转换成base64格式
    transBase64FromImage(image){
      let canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(image,0,0,image.width,image.height);
      // 可选其他值 image/jpeg
      return canvas.toDataURL("image/png");
    },
    // base64转成files
    transformToFiles(dataurl,filename){
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while(n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr],filename,{type:mime});
    },
    handleSuccess({data:url,code,msg},{name}){
      if(code !== 200) {
        this.$message.error(msg);
      } else {
        this.$emit('handleFile',[{url,name}]);
      }
    },
    clearFile(){
      this.$emit('removeImage');
      this.$emit('handleFile',[]);
    },
    finish(){
      let _this = this;
      this.$refs.cropper.getCropBlob(async(data) => {
        let formData = new FormData();
        console.log(data);
        if(data) {
          var timestamp = new Date().getTime() + '.jpg';
          //  将blob格式转换为文件。File() 构造器创建新的 File 对象实例。
          const newFile = new window.File([data],timestamp);

          formData.append('file',newFile);
          formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
          // 设置请求头
          const config = {
            headers:{
              'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
              'token':localStorage.getItem("token")
            }
          };
          console.log(this.$urls.ip + this.$urls.uploadFile);
          // 使用axios或其他HTTP客户端发送请求
          if(this.upImg === 0) {
            axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
              .then(response => {
                console.log(response.data);
                this.imageId = response.data.data.id;
                this.imageUrl = this.$urls.ip + "/" + response.data.data.url;
                this.dialogVisible = false;
              }).catch(error => {
              console.log(error);
              if(error) {
                this.$message.error("上传失败");
              }
            });
          } else {
            axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
              .then(response => {
                console.log(response.data);
                this.imageId1 = response.data.data.id;
                this.imageUrl1 = this.$urls.ip + "/" + response.data.data.url;
                this.dialogVisible = false;
              }).catch(error => {
              console.log(error);
              if(error) {
                this.$message.error("上传失败");
              }
            });
          }
        } else {
          this.$message.warning('请重新截图');
        }
      });
      _this.$forceUpdate();
    },
    uploadFile(content){
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
        .then(response => {
          console.log(response.data);
          this.imageId = response.data.data.id;
          this.imageUrl = this.$urls.ip + "/" + response.data.data.url;
        }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess1(response){
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    uploadFile1(content){
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
        .then(response => {
          console.log(response.data);
          this.imageId1 = response.data.data.id;
          this.imageUrl1 = this.$urls.ip + "/" + response.data.data.url;
        }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess(response){
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    addNotice(stateId){
      const params = {
        'title':this.ediTitle,
        "order":1,
        'onLine':stateId,
        'sFileId':this.imageId, /*缩略图id*/
        'bFileId':this.imageId1, /*详情id*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.newBanner,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("添加失败");
        }
      });
    },
    changeNotice(stateId){
      const params = {
        'id':this.id,
        'title':this.ediTitle,
        "order":1,
        'onLine':stateId,
        'sFileId':this.imageId, /*缩略图id*/
        'bFileId':this.imageId1, /*详情id*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateBanner,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack(){
      if(this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    timestampToTime(timestamp){/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return Y + M + D + h + m + s;
    },
    getImgList(id){
      const params = {
        'id':id,
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if(this.ediTitle) {
        params["title"] = this.ediTitle; /*角色id*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getBannerList,params,headers).then(res => {
        console.log("getImgList：",res.data.data);
        this.li_notice = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    init_View(){
      let data = this.li_notice[0];
      this.ediTitle = data['title'];
      if(data["sFile"]) { /*缩略图id*/
        this.imageId = data["sFile"]["id"];
        this.imageUrl = `${this.$urls.ip}/${data["sFile"]["url"]}`;
      }
      if(data["bFile"]) { /*详情id*/
        this.imageId1 = data["bFile"]["id"];
        this.imageUrl1 = `${this.$urls.ip}/${data["bFile"]["url"]}`;
      }
    }
  },
  mounted(){ /*页面加载时调用*/
    const value = this.$route.query.key;
    if(value === "addImg") {
      this.h_text = "新增轮播图";
      this.noOperate = false;
    } else {
      this.id = parseInt(this.$route.query.id);
      if(this.$route.query.operate === 'w') {
        this.noOperate = false;
        this.h_text = "修改轮播图信息";
      } else {
        this.noOperate = true;
        this.h_text = "查看轮播图信息";
      }
      this.getImgList(this.id);
    }
  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
#imgGlSon {
  height: 94vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/imgGlSon.vue